import NextFlockDetails from './NextFlockDetails';

export default NextFlockDetails;
